import React, { FC, useContext } from "react";
import { Grid, LinearProgress, Theme, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { TearSheetIndication } from "../../typescript/interfaces/data";
import { LoadingContext } from "../../context";
import config from "../../config";
import Hyperlink from "../Common/Hyperlink";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginBottom: "12px",
  },
  header: {
    fontSize: "0.9rem",
    marginBottom: "0.6rem",

    display: "flex",
    justifyContent: "center",
  },
  indicationsContainer: {
    backgroundColor: theme.palette.background.default,
    padding: "0.5rem 0.5rem 0.5rem 0.5rem",
    minHeight: "1rem",
  },
  stage: {
    textAlign: "center",
    "& > p": {
      fontWeight: 600,
    },
  },
  nameText: {
    whiteSpace: "break-spaces",
  },
  progress: {
    width: "100%",
  },
}));

interface IndicationsProps {
  sectionTitle: string;
  indications: TearSheetIndication[];
}

const Indications: FC<IndicationsProps> = ({ sectionTitle, indications }) => {
  const classes = useStyles();

  const [loadingContext, setLoadingContext] = useContext(LoadingContext);

  return (
    <Grid container className={classes.container}>
      <Grid container justify="center">
        <Typography className={classes.header} variant="h6">
          {sectionTitle}
        </Typography>
      </Grid>
      <Grid container className={classes.indicationsContainer}>
        {loadingContext.drugPopup ? (
          <Grid container>
            <LinearProgress className={classes.progress} />
          </Grid>
        ) : (
          <>
            {indications.length > 0 ? (
              <Grid container>
                {indications.map((tsi, idx) => {
                  const { status, indication, diseaseState } = tsi;

                  return (
                    <Grid item xs={12} key={idx}>
                      <Grid container>
                        <Grid item xs={3} wrap="nowrap" className={classes.stage}>
                          <Typography variant="body2">{status?.stage}:</Typography>
                        </Grid>
                        <Grid item xs={9}>
                          <Grid container>
                            <Grid item className={classes.nameText}>
                              <Typography variant="body2">{indication.name}: </Typography>
                            </Grid>
                            <Grid item className={classes.nameText}>
                              <Hyperlink url={`${config.USER_URL}/Pharma/Disease/${diseaseState.id}`}>
                                <Typography variant="body2">{diseaseState.name}</Typography>
                              </Hyperlink>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            ) : (
              <Grid container justify="center">
                <Typography variant="body2">No {sectionTitle}</Typography>
              </Grid>
            )}
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default Indications;
